/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_App_NameInputs */

const en_common_app_name = /** @type {(inputs: Common_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening`)
};

const es_common_app_name = /** @type {(inputs: Common_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening`)
};

/**
* | output |
* | --- |
* | "Listening" |
*
* @param {Common_App_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_app_name = /** @type {((inputs?: Common_App_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_App_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_app_name(inputs)
	return en_common_app_name(inputs)
});